

export const FETCH_VEHICLE_ACTYPE_LIST = {
    START: 'FETCH_VEHICLE_ACTYPE_LIST_START',
    SUCCESS: 'FETCH_VEHICLE_ACTYPE_LIST_SUCCESS',
    ERROR: 'FETCH_VEHICLE_ACTYPE_LIST_ERROR',
  };
  export const TOAST = {
    RESET: 'RESET_TOAST',
  };
  export const FETCH_VEHICLE_ACTYPE_INIT="FETCH_VEHICLE_ACTYPE_INIT"
  export const SET_DELETE_CONFIRMATION_POPUP_VISIBILITY =
  'SET_DELETE_CONFIRMATION_POPUP_VISIBILITY';


  
export const INIT_CREATE_VEHICLE_ACTYPE_SCREEN =
'INIT_CREATE_VEHICLE_ACTYPE_SCREEN';

export const CREATE_VEHICLE_ACTYPE = {
START: 'CREATE_VEHICLE_ACTYPE_START',
SUCCESS: 'CREATE_VEHICLE_ACTYPE_SUCCESS',
ERROR: 'CREATE_VEHICLE_ACTYPE_ERROR',
};

export const EDIT_VEHICLE_ACTYPE = {
START: 'EDIT_VEHICLE_ACTYPE_START',
SUCCESS: 'EDIT_VEHICLE_ACTYPE_SUCCESS',
ERROR: 'EDIT_VEHICLE_ACTYPE_ERROR',
};

export const FETCH_VEHICLE_ACTYPE_DETAIL = {
  START: 'FETCH_VEHICLE_ACTYPE_DETAIL_START',
  SUCCESS: 'FETCH_VEHICLE_ACTYPE_DETAIL_SUCCESS',
  ERROR: 'FETCH_VEHICLE_ACTYPE_DETAIL_ERROR',
};
export const EXPORT_VEHICLE_ACTYPE = {
  START: 'EXPORT_VEHICLE_ACTYPE_START',
  SUCCESS: 'EXPORT_VEHICLE_ACTYPE_SUCCESS',
  ERROR: 'EXPORT_VEHICLE_ACTYPE_ERROR',
};
export const VEHICLE_MODELDD = {
  START: 'VEHICLE_MODELDD_START',
  SUCCESS: 'VEHICLE_MODELDD_SUCCESS',
  ERROR: 'VEHICLE_MODELDD_ERROR',
};

export const VEHICLE_ACTYPE_DD = {
  START: 'VEHICLE_ACTYPE_DD_START',
  SUCCESS: 'VEHICLE_ACTYPE_DD_SUCCESS',
  ERROR: 'VEHICLE_ACTYPE_DD_ERROR',
};

export const DELETE_VEHICLE_ACTYPE = {
  START: 'DELETE_VEHICLE_ACTYPE_START',
  SUCCESS: 'DELETE_VEHICLE_ACTYPE_SUCCESS',
  ERROR: 'DELETE_VEHICLE_ACTYPE_ERROR',
};

export const VEHICLE_ACTYPE_SAVE_TABLE_STATE = 'VEHICLE_ACTYPE_SAVE_TABLE_STATE';